import { Link } from "react-router-dom";
import { ArrowRight, Phone, MessageCircle } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { useSettings } from "../lib/hooks";
import { telLink, waLink, track } from "../lib/api";

export default function CtaBand({ title = "Let\u2019s Discuss What\u2019s Possible for Your Home." }) {
  const { data: settings } = useSettings();
  return (
    <section data-testid="cta-band" className="bg-obsidian blueprint-grid text-white">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-20 md:py-32">
        <Reveal>
          <Overline>[ Get Started ]</Overline>
          <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tighter mt-6 max-w-3xl">
            {title}
          </h2>
          <p className="text-white/60 text-base md:text-lg leading-relaxed mt-6 max-w-xl">
            A conversation costs nothing and commits you to nothing. Tell us about your home and what you
            would like to change — we will give you honest, informed advice.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mt-10">
            <Link
              to="/request-a-consultation"
              data-testid="cta-consultation-button"
              className="btn-sheen group inline-flex items-center justify-center gap-3 bg-ember hover:bg-emberdark text-white font-semibold tracking-wide px-8 py-4 transition-colors duration-300"
            >
              Request a Consultation
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <a
              href={waLink(settings)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("whatsapp_click", { location: "cta_band" })}
              data-testid="cta-whatsapp-button"
              className="inline-flex items-center justify-center gap-3 border border-white/25 hover:border-white text-white px-8 py-4 transition-colors duration-300"
            >
              <MessageCircle size={16} strokeWidth={1.5} /> WhatsApp NOOR
            </a>
            <a
              href={telLink(settings)}
              onClick={() => track("phone_click", { location: "cta_band" })}
              data-testid="cta-call-button"
              className="inline-flex items-center justify-center gap-3 border border-white/25 hover:border-white text-white px-8 py-4 transition-colors duration-300"
            >
              <Phone size={16} strokeWidth={1.5} /> Call NOOR
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
